export const MEXICO_CITY_AREA_CODE = '55'

export const LOCAL_STORAGE_SKIP_HOME_KEY = 'padnet:skip_home'

export const LOCAL_STORAGE_SKIP_PACKAGES_KEY = 'padnet:skip_packages'
